import { render, staticRenderFns } from "./SupportBtn.vue?vue&type=template&id=1a3a4eec"
var script = {}
import style0 from "./SupportBtn.vue?vue&type=style&index=0&id=1a3a4eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports